import { useState } from 'react'

export default function TrekReassurance({ trek }) {
  const [expanded, setExpanded] = useState(false)
  const points = trek.reassurance || []

  if (!points.length) return null

  return (
    <div style={{ marginBottom: '48px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 600 }}>Planning your way.</h3>
        <button
          onClick={() => setExpanded(e => !e)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-mid)', fontSize: '12px' }}
        >
          {expanded ? 'Show less' : 'Show details'}
        </button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px' }}>
        {points.map(p => (
          <div key={p.title} style={{ display: 'flex', gap: '10px' }}>
            <span style={{ fontSize: '18px' }}>{p.icon}</span>
            <div>
              <div style={{ fontSize: '13px', fontWeight: 500, color: 'var(--ink)' }}>{p.title}</div>
              {expanded && (
                <p style={{ fontSize: '12px', color: 'var(--ink-mid)', lineHeight: 1.5, marginTop: '4px' }}>{p.detail}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
